import { useState, useEffect } from 'react';
import ReactSelect from 'react-select';
import {
  Formfield,
  FormfieldProps,
} from '@designsystem/stories/03-molecules/Formfield';
import { EnabledSelectOptions } from '@fhnw/components/Blocks/SolarSearch/lib';

export interface SelectFieldProps extends FormfieldProps {
  /**
   * Whether the inserted value is invalid.
   */
  isInvalid?: boolean;
  /**
   * A placeholder text displayed when the input field is empty.
   */
  placeholder?: string;
  /**
   * Type of the input.
   */
  type?: string;
  /**
   * The ID of the input field.
   */
  id?: string;
  /**
   * The name of the input field.
   */
  name?: string;
  /**
   * The value of the input field.
   */
  value?: string | string[] | EnabledSelectOptions | EnabledSelectOptions[];
  /**
   * Whether the input field is disabled.
   */
  isDisabled?: boolean;
  /**
   * The onChange handler.
   */
  onChange?: (value: any) => void;
  /**
   * The onClick handler.
   */
  onClick?: () => void;
  options: Array<any>;
  isMulti?: boolean;
}

const SelectField = ({
  label,
  labelRequired,
  description,
  errorMessage,
  isRequired = false,
  isInvalid,
  isDisabled,
  ...props
}: SelectFieldProps) => {
  const [isClient, setIsClient] = useState(false);

  // Must be deleted once
  // https://github.com/JedWatson/react-select/issues/5459 is fixed.
  useEffect(
    () => setIsClient(true),
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [],
  );

  return (
    <Formfield
      htmlFor={props?.id}
      label={label}
      description={description}
      isRequired={isRequired}
      labelRequired={labelRequired}
      errorMessage={errorMessage}
    >
      {isClient && (
        <div
          className={['input', 'input--select', props?.className].join(' ')}
          data-error={(isInvalid && '1') || null}
        >
          <ReactSelect classNamePrefix="react-select" {...props} />
        </div>
      )}
    </Formfield>
  );
};

export default SelectField;
